/**
 * Date utility functions
 *
 * DEPRECATED: Use @/utils/aging for days past due calculations.
 * This file exists for backwards compatibility only.
 */

import { calculateDaysPastDue as calculateAgingFromInvoice } from '@/utils/aging'

/**
 * @deprecated Use calculateDaysPastDue from @/utils/aging instead
 *
 * Calculate the number of days past the due date
 * Returns 0 if the invoice is not yet due
 */
export function calculateDaysPastDue(dueDate: string | Date): number {
  const today = new Date()
  today.setHours(0, 0, 0, 0) // Reset time to start of day

  const due = new Date(dueDate)
  due.setHours(0, 0, 0, 0) // Reset time to start of day

  if (today <= due) {
    return 0 // Not past due
  }

  const diffTime = today.getTime() - due.getTime()
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))

  return diffDays
}

/**
 * Enrich invoice data with calculated days_past_due
 * Uses the new aging calculation that considers status and balance
 */
export function enrichInvoicesWithAging<T extends { due_date: string | Date; status: string; balance_due: number }>(
  invoices: T[]
): (T & { days_past_due: number })[] {
  return invoices.map(invoice => ({
    ...invoice,
    days_past_due: calculateAgingFromInvoice(invoice)
  }))
}
